require('./bootstrap');

import directives from "./directives";
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { VueMaskDirective } from 'v-mask';
import { i18n } from 'vue-lang-router';

axios.defaults.withCredentials = true;

const VueScrollTo = require('vue-scrollto');
const app = createApp(App);
directives.forEach(directive => {
  app.directive(directive.name, directive);
});
const vMaskV2 = VueMaskDirective;
const vMaskV3 = {
  beforeMount: vMaskV2.bind,
  updated: vMaskV2.componentUpdated,
  unmounted: vMaskV2.unbind
};

app.config.globalProperties.valuta = 'грн';
app
  .use(router)
  .use(store)
  .use(i18n)
  .use(VueScrollTo, {
    duration: 900,
    easing: "linear",
    offset: 0,
    y: true
  })
  .directive('mask', vMaskV3)
  .mount('#app');
